import React, { useState, useEffect } from 'react';
import { Checkbox, Modal, Select, message } from 'antd';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import InputStyled from 'components/InputStyled';
import { charactersApis } from 'apis/characters/charactersApis';
import { ISupportLanguage } from 'utils/types/storyTypes';
import SelectStyled from 'components/SelectStyled';
import { IVisible } from '..';

/**
 * * 리소스 - 미니컷 등록 모달
 */

interface IProps {
  visible: IVisible;
  langList: ISupportLanguage[] | null;
  data: any | null;
  detailData: any;
  index: number;
  setData: React.Dispatch<React.SetStateAction<any | null>>;
  setVisible: React.Dispatch<React.SetStateAction<any>>;
  selectedEl: any;
}

const EditLangModal = ({
  langList,
  data,
  detailData,
  index,
  setData,
  visible,
  setVisible,
  selectedEl,
}: IProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>('');
  const [langSelect, setLangSelect] = useState<any>(null);

  useEffect(() => {
    if (selectedEl) {
      setInputValue(selectedEl?.data?.line_text);
      setLangSelect(selectedEl?.data?.lang);
    }
  }, [selectedEl]);

  const handleSubmit = async () => {
    const cloneData = JSON.parse(JSON.stringify(data));
    const cloneDetailData = JSON.parse(JSON.stringify(detailData));
    cloneDetailData.localizations[selectedEl?.i] = {
      ...selectedEl?.data,
      lang: langSelect,
      line_text: inputValue,
    };
    cloneData.lines[index] = cloneDetailData;
    setData(cloneData);
    handleClose();
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, editLang: false });
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleLanguageChange = (e: string) => {
    setLangSelect(e);
  };

  return (
    <CustomModal
      title='Edit character'
      visible={visible.editLang}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.save')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <div>
          <p className='title'>Language</p>
          <SelectStyled
            size='large'
            bordered={false}
            value={langSelect}
            // suffixIcon={
            //   <img src={isOpen ? arrowUp : arrowDown} alt="arrow" />
            // }
            style={{ width: '100%' }}
            onChange={(e) => {
              handleLanguageChange(`${e}`);
            }}
            options={langList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </div>
        <div>
          <p className='title'>Line text</p>
          <InputStyled
            value={inputValue}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
            maxLength={80}
          />
          <p className='length-subtext'>
            {typeof inputValue?.length === 'number'
              ? `${inputValue?.length}/80 characters`
              : '0/80 characters'}
          </p>
        </div>
      </SectionWarpper>
    </CustomModal>
  );
};

export default EditLangModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .checkbox-section {
    display: flex;
    align-items: center;
    & > * + * {
      margin-left: 48px;
    }
  }
  .checkbox-item {
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-weight: ${theme.fontWeights.normal};
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #000000;
    }
    & > * + * {
      margin-left: 8px;
    }
  }
`;
